import { render, staticRenderFns } from "./FooterStart.vue?vue&type=template&id=6bd9c59a&scoped=true&"
import script from "./FooterStart.vue?vue&type=script&lang=js&"
export * from "./FooterStart.vue?vue&type=script&lang=js&"
import style0 from "./FooterStart.vue?vue&type=style&index=0&id=6bd9c59a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd9c59a",
  null
  
)

export default component.exports